import * as Actions from '../actions/conversation.actions'
import * as R from 'ramda'
import moment from 'moment'

const MAX_CONVERSATION_LIST = 10

const initialState = {
  hasUnreadMessage: false,
  isInConversationRoom: false,
  conversationListData: [],
  hasMore: true,
  isLoading: false,
  error: undefined,
  search: null,
  limit: MAX_CONVERSATION_LIST,
  lastKey: null,
  fetchedAt: '',
  historyIdSelected: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case Actions.LIST_CLEAR_DATA:
      return {
        ...state,
        conversationListData: [],
        lastKey: null,
      }
    case Actions.SET_UNREAD_MSG:
      return { ...state, hasUnreadMessage: action.payload.hasUnreadMessage }
    case Actions.SET_IS_IN_CONV_ROOM:
      return {
        ...state,
        isInConversationRoom: action.payload.isInConversationRoom,
      }
    case Actions.LIST_REFETCH:
      let newState = {
        ...state,
        conversationListData: [],
        isLoading: true,
        error: undefined,
        hasMore: true,
        lastKey: null,
        fetchedAt: moment(),
      }
      if (action.payload['fetchedType']) {
        newState['fetchedType'] = action.payload['fetchedType']
      }

      return newState
    case Actions.LIST_FETCH_INIT:
      return {
        ...state,
        isLoading: true,
        error: undefined,
        hasMore: true,
      }
    case Actions.LIST_FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: undefined,
        conversationListData: action.payload,
        lastKey: action.key,
      }
    case Actions.LIST_FETCH_FINAL:
      return {
        ...state,
        isLoading: false,
        error: undefined,
        conversationListData: action.payload,
        hasMore: false,
      }
    case Actions.LIST_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
        conversationListData: [],
        error: action.payload,
      }
    case Actions.LIST_FETCH_EMPTY:
      return {
        ...state,
        isLoading: false,
        conversationListData: [],
        hasMore: false,
      }
    case Actions.LIST_FETCH_MORE:
      return {
        ...state,
        fetchedAt: moment(),
      }
    case Actions.UPDATE_HISTORY_ID:
      return {
        ...state,
        historyIdSelected: action.payload,
      }
    case Actions.UPDATE_CONVERSATION_LIST:
      return {
        ...state,
        conversationListData: action.payload,
      }
    case Actions.UPDATE_BADGE:
      const newArray = R.map((item) => {
        if (item.historyId === R.path(['payload', 'historyId'], action)) {
          item = R.set(R.lensProp('isRead'), true, item)
          item.dataLastMessage.lastMessage.is_read = true
        }
        return item
      })(R.prop('conversationListData')(state))
      return {
        ...state,
        conversationListData: newArray,
      }
    default: {
      return state
    }
  }
}
